export default function loadFonts(k) {
  k.loadFont("gb", "./assets/gb.ttf");
}